import React from "react"

const Footer = () => {
    const currentYear = new Date().getFullYear()

    return (
        <footer>
            <div className="container">
                <p className="copyright text-center mb-1"style={{ fontWeight: "100", fontSize: "10pt" }}>&copy; {currentYear} Mantap Payroll</p>
            </div>
        </footer>
    )
}

export default Footer
